import moment from 'moment';
import { DashboardCOMLayoutProps } from '../DashboardCOM.types';
import { useMemo } from 'react';
import { calculateProgressionPercentage } from '../../../../../../utils/helpers/numbers/calculateProgressionPercentage';

export default ({ data }: DashboardCOMLayoutProps) => {
  // const formattedData = useMemo(
  //   () => {},
  //   [data]
  // )

  const wonStats = useMemo(
    () =>
      [...Array(6)].map((_, index) => {
        const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',');
        return (
          data?.won.find((item) => item.month === parseInt(month) && item.year === parseInt(year))
            ?.count || 0
        );
      }),
    [data]
  );

  // const totalStats = useMemo(
  //   () => (
  //     [...Array(6)].map((_, index) => {
  //       const [month, year] = moment().subtract(index, 'month').format('M,Y').split(',')
  //       return data?.total.find(item => item.month === parseInt(month) && item.year === parseInt(year))?.count || 0
  //     })
  //   ),
  //   [data]
  // )

  return (
    <section className="dashboard__sellers">
      <div className="dashboard__sellers-title-header">
        <span className="dashboard__sellers-title">
          Prospects convertis{' '}
          <span style={{ color: 'var(--gray-5)', fontWeight: 'normal', fontSize: 12 }}>
            (durant les 6 derniers mois)
          </span>
        </span>
      </div>
      <table className="dashboard__sellers-table">
        <thead>
          <tr>
            <th>Mois</th>
            <th>Prospects</th>
          </tr>
        </thead>
        <tbody>
          {wonStats?.map((_, index) => {
            const progression =
              calculateProgressionPercentage(wonStats[index + 1] || 0, wonStats[index]) || 0;
            return (
              <tr key={index}>
                <td style={{ textTransform: 'capitalize' }}>
                  {moment().subtract(index, 'month').format('MMMM')}
                </td>
                <td className={`performance${progression < 0 ? ' performance--negative' : ''}`}>
                  {wonStats[index]} {progression ? <span>{progression.toFixed(2)}%</span> : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  );
};
